import React, {PureComponent} from "react"
import Dropzone from "react-dropzone"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import getBase64 from "@irati/utils/images/getBase64"
import {BRAND_LOGO_DIMENSIONS} from "@irati/brand/constants/brand"
import {H1, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

import DropZoneWrapper from "./styled/DropZoneWrapper"
import DropZoneImg from "./styled/DropZoneImg"
import add_a_file from "./add-a-file.png"
import BackLink from "./BackLink"

const UnderlineStrong = styled.strong`
  text-decoration: underline;
  cursor: pointer;
`

interface Props {
  onComplete: (file: File, contents: string) => void,
  handleBackToSelect: () => void
}

class UploadLogoStep extends PureComponent<Props> {
  onFileDropped(acceptedFile: File, rejectedFile: File) {
    if (rejectedFile.length > 0) {
      console.error("REJECTED FILE")
      return
    }
    const file = acceptedFile[0]
    getBase64(file).then((contents: string) => {
      this.props.onComplete(file, contents)
    })
  }

  render() {
    return (
      <>
        <BackLink id="backToPage_button" onClick={this.props.handleBackToSelect} text="admin.components.brandSettings.logoAndColours" />
        <H1 marginBottom={4}>
          <FormattedMessage id="admin.components.updateLogoStep.title" />
        </H1>
        <Body>
          <FormattedMessage
            id="admin.components.updateLogoStep.subTitle"
            values={{width: BRAND_LOGO_DIMENSIONS.width * 2, height: BRAND_LOGO_DIMENSIONS.height * 2}} />
        </Body>
        <DropZoneWrapper>
          <Dropzone
            className="logo-drop-zone"
            name="fieldname"
            accept="image/jpg,image/jpeg,image/png"
            multiple={false}
            onDrop={this.onFileDropped.bind(this)}>
            <Flex justifyContent="center" alignItems="center" height="100%" className="drop-contents">
              <DropZoneImg src={add_a_file} />
              <Body>
                <FormattedMessage
                  id="admin.components.updateLogoStep.headerFour"
                  values={{browse: <UnderlineStrong>
                    <FormattedMessage id="admin.components.updateLogoStep.header.browse" />
                  </UnderlineStrong>}} />
              </Body>
            </Flex>
          </Dropzone>
        </DropZoneWrapper>
      </>
    )
  }
}

export default UploadLogoStep
